
import React, { Component } from "react";
import {
  Row,
  Col,
  Button,
  Form,
  Modal
} from "react-bootstrap";

export default class NodeInsertionModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
        }
    }
    render() {
        const {
        } = this.state;
        const {
            showInsertModal,
            toggleModal,
            insertType,
            handleChange,
            validator,
            mcode,
            title,
            groupTitle,
            displayOrder,
            addBtnStyle,
            closeBtnStyle,
            handleSubmit,
            titles
        } = this.props
        return (
            <div>
            <Modal
              size="lg"
              aria-labelledby="contained-modal-title-vcenter"
              centered
              show={showInsertModal}
              onHide={() => toggleModal()}
            >
              <Modal.Header closeButton>
                <Modal.Title>
                  {/* {"L" === this.state.insertType
                    ? `You are going to create an item in-between two items: ${this.state.pid}`
                    : `Create a leaf item as a child of item: ${this.state.pid}`}{" "} */}
                  {"L" === insertType
                    ? `You are going to create an item`
                    : `You are going to create an item`}
                </Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <Form>
                  <Row className="my-5">
                    <Form.Group
                      as={Col}
                      md="6"
                      controlId="exampleForm.ControlInput1"
                      className="mb-3"
                    >
                      <Form.Label>ID</Form.Label>
                      <Form.Control
                        type="text"
                        name="mcode"
                        placeholder="ID"
                        onChange={handleChange}
                      />
                      {validator.message(
                        "mcode",
                        mcode,
                        "required|alpha_num",
                        {
                          className: "text-danger",
                          messages: {
                            required: "Id is required.",
                          },
                        }
                      )}
                    </Form.Group>
                    <Form.Group
                      as={Col}
                      md="6"
                      controlId="exampleForm.ControlInput1"
                    >
                      <Form.Label>Main Title</Form.Label>
                      <Form.Control
                        type="text"
                        name="title"
                        placeholder="Main Title"
                        onChange={handleChange}
                        className="mb-3"
                      />
                      {validator.message(
                        "title",
                        title,
                        "required",
                        {
                          className: "text-danger",
                          messages: {
                            required: "Main title is required.",
                          },
                        }
                      )}
                    </Form.Group>
                    <Form.Group
                      as={Col}
                      md="6"
                      controlId="exampleForm.ControlInput1"
                      className="my-3"
                    >
                      <Form.Label>Group Title</Form.Label>
                      <Form.Select
                        aria-label="Default select example"
                        name="groupTitle"
                        value={groupTitle}
                        onChange={handleChange}
                        className="mb-3"
                      >
                        <option value="">Select</option>
                        {titles.length>0?(titles.map((title)=>(
                            <option key={title.group_id} value={title.group_id}>
                              {title.group_title}
                            </option>
                          ))):(
                          <option value="">No titles available</option>
                        )}
                      </Form.Select>
                      {validator.message(
                        'groupTitle',
                        groupTitle,
                        'required|max:20', {
                          className: "text-danger",
                          messages: {
                            required: "Group title is required.",
                          },
                        })}
                    </Form.Group>
  
                    <Form.Group
                      as={Col}
                      md="6"
                      controlId="exampleForm.ControlInput1"
                      className="mt-3"
                    >
                      <Form.Label>Display Order</Form.Label>
                      <Form.Control
                        type="number"
                        name="displayOrder"
                        step={1}
                        min={0}
                        max={100}
                        value={displayOrder}
                        defaultValue={0}
                        placeholder="Display Order"
                        onChange={handleChange}
                        className="mb-3"
                      />
                    </Form.Group>
                    <Form.Group
                      as={Col}
                      md="6"
                      controlId="exampleForm.ControlInput1"
                    >
                      <Row className="px-0 d-flex justify-content-between">
                        <Form.Label className="col-auto px-0">
                          Hide this item
                        </Form.Label>
                        <div className="col-auto px-0">
                          <Form.Check
                            type="checkbox"
                            name="flg_node_hide"
                            onChange={handleChange}
                            className="calendar-checkbox"
                          />
                        </div>
                      </Row>
                    </Form.Group>
                  </Row>
                </Form>
              </Modal.Body>
              <Modal.Footer>
                <Button
                  variant="primary"
                  style={ addBtnStyle }
                  onClick={(event) => handleSubmit(event)}
                >
                  Add Item
                </Button>
                <Button
                  id="modal-close-button"
                  style={ closeBtnStyle }
                  onClick={() => toggleModal()}
                >
                  Close
                </Button>
              </Modal.Footer>
            </Modal>
            </div>
        )
    }
}



